import { MeasurementConversion } from "../../../../../../CoStar/Api/EnterpriseSub2/Detail/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.MeasurementConversion */
export { MeasurementConversion };
import { PropertyType } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.PropertyType */
export { PropertyType };
import { ListingType } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.ListingType */
export { ListingType };
import { ListingAdLevel } from "../../../../../../CoStar/Api/ListingAdvertising/ViewModels/Enum/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.ListingAdLevel */
export { ListingAdLevel };
import { SpaceUse } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.SpaceUse */
export { SpaceUse };
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.CarouselType */
export var CarouselType;
(function (CarouselType) {
    CarouselType[CarouselType["Image"] = 0] = "Image";
    CarouselType[CarouselType["Video"] = 1] = "Video";
    CarouselType[CarouselType["MatterPort"] = 2] = "MatterPort";
    CarouselType[CarouselType["FloorPlans"] = 3] = "FloorPlans";
})(CarouselType || (CarouselType = {}));
import { CurrencyType } from "../../../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.CurrencyType */
export { CurrencyType };
import { AreaMeasure } from "../../../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.AreaMeasure */
export { AreaMeasure };
import { RentBasis } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.RentBasis */
export { RentBasis };
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.EventSource */
export var EventSource;
(function (EventSource) {
    EventSource[EventSource["LoopNet"] = 1] = "LoopNet";
    EventSource[EventSource["LoopNetReinforcementAd"] = 2] = "LoopNetReinforcementAd";
    EventSource[EventSource["LoopLink"] = 3] = "LoopLink";
    EventSource[EventSource["LoopNetNativeApp"] = 4] = "LoopNetNativeApp";
    EventSource[EventSource["CityFeet"] = 10] = "CityFeet";
    EventSource[EventSource["Realla"] = 20] = "Realla";
    EventSource[EventSource["CDXMailCampaign"] = 31] = "CDXMailCampaign";
    EventSource[EventSource["LiveIntentNewsletter"] = 32] = "LiveIntentNewsletter";
    EventSource[EventSource["CoStarRetargetingAd"] = 33] = "CoStarRetargetingAd";
    EventSource[EventSource["Showcase"] = 40] = "Showcase";
    EventSource[EventSource["CoStarSuite"] = 50] = "CoStarSuite";
    EventSource[EventSource["CoStarNativeApp"] = 54] = "CoStarNativeApp";
    EventSource[EventSource["CoStarReinforcementAd"] = 60] = "CoStarReinforcementAd";
    EventSource[EventSource["TenX"] = 70] = "TenX";
    EventSource[EventSource["TenXNativeApp"] = 74] = "TenXNativeApp";
    EventSource[EventSource["TenXDOS"] = 75] = "TenXDOS";
    EventSource[EventSource["MarketingCenter"] = 80] = "MarketingCenter";
})(EventSource || (EventSource = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.ListingTypeOptions */
export var ListingTypeOptions;
(function (ListingTypeOptions) {
    ListingTypeOptions[ListingTypeOptions["None"] = 0] = "None";
    ListingTypeOptions[ListingTypeOptions["RestrictedVisibility"] = 1] = "RestrictedVisibility";
    ListingTypeOptions[ListingTypeOptions["Licensed"] = 2] = "Licensed";
})(ListingTypeOptions || (ListingTypeOptions = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.PinType */
export var PinType;
(function (PinType) {
    PinType[PinType["None"] = 0] = "None";
    PinType[PinType["Normal"] = 1] = "Normal";
    PinType[PinType["SuppressedAddress"] = 2] = "SuppressedAddress";
    PinType[PinType["Disconnected"] = 3] = "Disconnected";
})(PinType || (PinType = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.SaleEntityType */
export var SaleEntityType;
(function (SaleEntityType) {
    SaleEntityType[SaleEntityType["Property"] = 0] = "Property";
    SaleEntityType[SaleEntityType["Condo"] = 1] = "Condo";
})(SaleEntityType || (SaleEntityType = {}));
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.AccessControlLevelType */
export var AccessControlLevelType;
(function (AccessControlLevelType) {
    AccessControlLevelType[AccessControlLevelType["None"] = 0] = "None";
    AccessControlLevelType[AccessControlLevelType["Registration"] = 10] = "Registration";
    AccessControlLevelType[AccessControlLevelType["ConfidentialityAgreement"] = 20] = "ConfidentialityAgreement";
    AccessControlLevelType[AccessControlLevelType["DetailView"] = 30] = "DetailView";
})(AccessControlLevelType || (AccessControlLevelType = {}));
import { TransitType } from "../../../../../../CoStar/Api/EnterpriseSub2/Detail/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.TransitType */
export { TransitType };
import { PropertyGroupSubtype } from "../../../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.PropertyGroupSubtype */
export { PropertyGroupSubtype };
import { StarRating } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.StarRating */
export { StarRating };
import { SaleStatus } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.SaleStatus */
export { SaleStatus };
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.ListingStatus */
export var ListingStatus;
(function (ListingStatus) {
    ListingStatus[ListingStatus["None"] = 0] = "None";
    ListingStatus[ListingStatus["Active"] = 1] = "Active";
    ListingStatus[ListingStatus["Pending"] = 2] = "Pending";
    ListingStatus[ListingStatus["OffMarket"] = 3] = "OffMarket";
    ListingStatus[ListingStatus["Terminate"] = 4] = "Terminate";
    ListingStatus[ListingStatus["SubscriptionHold"] = 5] = "SubscriptionHold";
    ListingStatus[ListingStatus["Unpublished"] = 6] = "Unpublished";
    ListingStatus[ListingStatus["AwaitingVerification"] = 7] = "AwaitingVerification";
    ListingStatus[ListingStatus["UserDeleted"] = 8] = "UserDeleted";
    ListingStatus[ListingStatus["Upsell"] = 9] = "Upsell";
})(ListingStatus || (ListingStatus = {}));
import { RentRateType } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.RentRateType */
export { RentRateType };
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.BuildOut */
export var BuildOut;
(function (BuildOut) {
    BuildOut[BuildOut["None"] = 0] = "None";
    BuildOut[BuildOut["StandardOffice"] = 1] = "StandardOffice";
    BuildOut[BuildOut["FinancialServices"] = 2] = "FinancialServices";
    BuildOut[BuildOut["ProfessionalServices"] = 3] = "ProfessionalServices";
    BuildOut[BuildOut["LawFirm"] = 4] = "LawFirm";
    BuildOut[BuildOut["CallCenter"] = 5] = "CallCenter";
    BuildOut[BuildOut["GovernmentFacility"] = 7] = "GovernmentFacility";
    BuildOut[BuildOut["LiveWork"] = 8] = "LiveWork";
    BuildOut[BuildOut["StandardIndustrial"] = 9] = "StandardIndustrial";
    BuildOut[BuildOut["StorageAndDistribution"] = 10] = "StorageAndDistribution";
    BuildOut[BuildOut["SelfStorage"] = 11] = "SelfStorage";
    BuildOut[BuildOut["Warehouse"] = 12] = "Warehouse";
    BuildOut[BuildOut["StandardRetail"] = 13] = "StandardRetail";
    BuildOut[BuildOut["RestaurantsAndCafes"] = 14] = "RestaurantsAndCafes";
    BuildOut[BuildOut["FastFood"] = 15] = "FastFood";
    BuildOut[BuildOut["Bank"] = 16] = "Bank";
    BuildOut[BuildOut["ConvenienceStore"] = 17] = "ConvenienceStore";
    BuildOut[BuildOut["DrinkingEstablishment"] = 18] = "DrinkingEstablishment";
    BuildOut[BuildOut["StandardFlex"] = 19] = "StandardFlex";
    BuildOut[BuildOut["StandardMedical"] = 21] = "StandardMedical";
    BuildOut[BuildOut["Dental"] = 22] = "Dental";
    BuildOut[BuildOut["PhysicalTherapy"] = 23] = "PhysicalTherapy";
    BuildOut[BuildOut["ResearchAndDevelopment"] = 24] = "ResearchAndDevelopment";
    BuildOut[BuildOut["Healthcare"] = 25] = "Healthcare";
    BuildOut[BuildOut["Specialty"] = 26] = "Specialty";
    BuildOut[BuildOut["ReligiousFacility"] = 28] = "ReligiousFacility";
    BuildOut[BuildOut["MovieTheater"] = 29] = "MovieTheater";
    BuildOut[BuildOut["PopupTemporary"] = 30] = "PopupTemporary";
    BuildOut[BuildOut["PoliceFireStation"] = 31] = "PoliceFireStation";
    BuildOut[BuildOut["PostOffice"] = 32] = "PostOffice";
    BuildOut[BuildOut["CarDealership"] = 33] = "CarDealership";
})(BuildOut || (BuildOut = {}));
import { SpaceTypes } from "../../../../../../CoStar/Api/Listings/ViewModels/Search/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.SpaceTypes */
export { SpaceTypes };
import { UseClasses } from "../../../../../../CoStar/Api/Listings/ViewModels/Search/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.UseClasses */
export { UseClasses };
import { PriceRateType } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.PriceRateType */
export { PriceRateType };
import { DateMeasure } from "../../../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.DateMeasure */
export { DateMeasure };
import { SpaceUsePropertyTypeInteraction } from "../../../../../../CoStar/Api/Listings/ViewModels/Search/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.SpaceUsePropertyTypeInteraction */
export { SpaceUsePropertyTypeInteraction };
import { LengthMeasure } from "../../../../../../CoStar/Api/Brokers/ViewModels/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.LengthMeasure */
export { LengthMeasure };
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.GeographyFilterType */
export var GeographyFilterType;
(function (GeographyFilterType) {
    GeographyFilterType[GeographyFilterType["Unknown"] = 0] = "Unknown";
    GeographyFilterType[GeographyFilterType["Property"] = 1] = "Property";
    GeographyFilterType[GeographyFilterType["PostalCode"] = 2] = "PostalCode";
    GeographyFilterType[GeographyFilterType["City"] = 3] = "City";
    GeographyFilterType[GeographyFilterType["Submarket"] = 5] = "Submarket";
    GeographyFilterType[GeographyFilterType["ResearchMarket"] = 7] = "ResearchMarket";
    GeographyFilterType[GeographyFilterType["County"] = 10] = "County";
    GeographyFilterType[GeographyFilterType["Subdivision"] = 11] = "Subdivision";
    GeographyFilterType[GeographyFilterType["ShoppingCenter"] = 14] = "ShoppingCenter";
    GeographyFilterType[GeographyFilterType["PostalCodeGroup"] = 16] = "PostalCodeGroup";
    GeographyFilterType[GeographyFilterType["Region"] = 17] = "Region";
    GeographyFilterType[GeographyFilterType["Cluster"] = 21] = "Cluster";
    GeographyFilterType[GeographyFilterType["Metro"] = 32] = "Metro";
    GeographyFilterType[GeographyFilterType["PropertyGroup"] = 42] = "PropertyGroup";
    GeographyFilterType[GeographyFilterType["TrueCity"] = 133] = "TrueCity";
    GeographyFilterType[GeographyFilterType["CensusRegion"] = 134] = "CensusRegion";
})(GeographyFilterType || (GeographyFilterType = {}));
import { FilterAction } from "../../../../../../CoStar/Api/Listings/ViewModels/Search/index.js";
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.FilterAction */
export { FilterAction };
/** CoStar.Api.LoopNet.MobileServices.ViewModels.Enums.Gender */
export var Gender;
(function (Gender) {
    Gender[Gender["Unknown"] = 0] = "Unknown";
    Gender[Gender["Female"] = 1] = "Female";
    Gender[Gender["Male"] = 2] = "Male";
})(Gender || (Gender = {}));
